<template>
  <div class="container-custom">
    <!-- breadscrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">About us</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 About Us</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="editHandler">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
    </div>

    <!-- block 1 -->
    <div class="block">
      <PageMenu :sections="sections">
        <component :is="sectionView" style="min-height: 800px;" :about="about"></component>
      </PageMenu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageMenu from '@/components/PageMenu.vue';
import BrandMessaging from '@/views/A_AboutUs/c/A-1-1_AboutUs_BrandMessaging.vue';
import CorporateInvestmentMessaging from '@/views/A_AboutUs/c/A-1-2_AboutUs_CorporateInvestmentMessaging.vue';
import PartnerEndorsement from '@/views/A_AboutUs/c/A-1-3_AboutUs_PartnerEndorsement.vue';
import CSR from '@/views/A_AboutUs/c/A-1-5_AboutUs_CSR.vue';
import VideoRotate from '@/views/A_AboutUs/c/A-1-7_ABoutUs_VideoRotate.vue';
import AboutAward from '@/views/A_AboutUs/c/A-1-8_AboutUs_Award.vue';

export default {
  components: {
    PageMenu,
    BrandMessaging,
    CorporateInvestmentMessaging,
    PartnerEndorsement,
    CSR,
    VideoRotate,
    AboutAward,
  },
  data: () => ({
    sections: [
      { name: 'Global Memory and Embedded Storage Expert', component: 'BrandMessaging' },
      { name: 'Corporate Introduction', component: 'CorporateInvestmentMessaging' },
      // { name: 'Moment of Glory', component: 'AboutAward' }, // 前台未使用，2026-08-22 隱藏
      { name: 'Leading of the Edge', component: 'PartnerEndorsement' },
      { name: 'Social Responsibility', component: 'CSR' },
      { name: 'Video Rotate', component: 'VideoRotate' },
    ],
  }),
  async created() {
    await this.getAbout();
  },
  computed: {
    ...mapState('about', ['about']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },

  methods: {
    ...mapActions('about', {
      getAbout: 'find',
      setAbout: 'setAbout',
    }),
    editHandler() {
      this.$router.push({
        name: 'AboutUsEdit',
        query: {
          section: this.$route.query.section,
        },
      });
    },
  },
};
</script>

<style></style>
